/**
 * Parola sifirlama talebi.
 *
 * ── HESAP SAYIMI ENGELI ──────────────────────────────────────────────────────
 * Sunucu, e-posta kayitli olsa da olmasa da AYNI cevabi verir. Bu ekran da
 * ayni disiplini korur: "Kayitli degil" DEMEZ. Aksi halde saldirgan hangi
 * e-postalarin sistemde oldugunu tek tek ogrenebilir.
 */

import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { api } from '@/lib/api';
import { Button, Field, Input } from '@/components/ui';
import { useI18n } from '@/lib/i18n';

export default function ForgotPassword() {
  const { t } = useI18n();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post('/auth/password-reset/request', { email: email.trim() });
    } catch {
      // Hata bile olsa AYNI ekrani gosteriyoruz — hata mesaji, e-postanin
      // kayitli olup olmadigini sizdirabilir.
    } finally {
      setBusy(false);
      setSent(true);
    }
  }

  if (sent) {
    return (
      <>
        <div>
          <h1 className="auth__title">{t('auth.resetLinkSent')}</h1>
          <p className="auth__sub">
            <strong>{email}</strong> {t('auth.resetLinkSentIfRegistered')}
          </p>
        </div>
        <div className="auth__ok">{t('auth.resetLinkValidity')}</div>
        <Link className="btn btn--secondary btn--lg" style={{ width: '100%' }} to="/giris">{t('auth.backToSignIn')}</Link>
      </>
    );
  }

  return (
    <>
      <div>
        <h1 className="auth__title">{t('auth.forgotPassword')}</h1>
        <p className="auth__sub">{t('auth.forgotSubtitle')}</p>
      </div>

      <form className="auth__form" onSubmit={handleSubmit} noValidate>
        <Field label={t('auth.email')} required>
          {({ id }) => (
            <Input
              id={id}
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              autoFocus
              required
            />
          )}
        </Field>

        <Button type="submit" variant="primary" size="lg" loading={busy}>
          {t('auth.sendLink')}
        </Button>
      </form>

      <p className="small muted" style={{ textAlign: 'center' }}>
        <Link to="/giris">{t('auth.backToSignIn')}</Link>
      </p>
    </>
  );
}
